import { PayOrderStatus } from '@tiendanube/common';

export const isPayableCharge = (status: PayOrderStatus) =>
  ['PENDING', 'FAILED', 'CANCELLED'].includes(status);
